import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import {DiscoverOpportunitiesService} from "../discoverOpportunities/discover-opportunities.service";

export const opportunityOptionsResolver: ResolveFn<boolean> = (route, state) => {
  return inject(DiscoverOpportunitiesService).getOptions();
};
